import e from "@dialpad/dialtone-tokens/layered/themes/tokens-123-colors.css?inline";
//#region themes/123.js
var t = { brand: {
	css: e,
	name: "123"
} };
//#endregion
export { t as default };
